<template>
  <div
    class="toolbar bg-white fixed w-full h-16 sm:h-16 md:h-20 flex justify-between text-blue items-stretch z-10 shadow-md">
    <router-link :to="{ name: 'home' }"
      class="brand w-24 md:w-32 flex flex-shrink-0 items-center justify-center pl-4 pr-3 md:px-5">
      <img src="/images/msg-logo-blue.svg" alt="Marine Stores Guide" class="block w-full">
    </router-link>
    <SearchBar class="relative flex flex-grow xl:flex-grow-0 xl:w-4/12 items-center" />
    <PrimaryNav class="xl:flex-grow" :show-menu="menuStatus" />
    <a href="#primary-nav" class="z-10 px-4 z-50 flex items-center relative xl:hidden" @click.prevent="toggleMenu()">
      <font-awesome-icon :icon="['far', 'bars']" class="ml-2 hover:ml-4 text-2xl" />
    </a>
  </div>
</template>
<script>
import PrimaryNav from './PrimaryNav'
import SearchBar from './SearchBar'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: {
    PrimaryNav,
    SearchBar
  },
  computed: {
    menuStatus() {
      return this.$store.state.menu.open;
    }
  },
  methods: {
    toggleMenu: function () {
      this.$store.commit('menu/toggleMenu')
    }
  },
}
</script>
<style></style>